import { Text, Markdown } from '@devfolioco/genesis';
import moment from '@helpers/moment';
import React from 'react';

// Helpers
const formatDate = date => moment(date, 'YYYY-MM-DD').format('MMMM YYYY');

const getDateRange = (start, end, isPresentCompany) => {
  const startDate = formatDate(start);
  const endDate = isPresentCompany ? 'Present' : formatDate(end);
  const dateRange = `${startDate} - ${endDate}`;

  return dateRange;
};

/**
 * Renders an experience item.
 */
const Experience = ({
  company: { name = '' },
  title = '',
  description = '',
  start,
  end,
  current_company: isPresentCompany,
}) => {
  const companyNameAndTitle = `${name} ${title ? `- ${title}` : ''}`;
  const showDates = start && (end || isPresentCompany);

  return (
    <>
      <Text size="larger" color="black-0" weight="bold">
        {companyNameAndTitle}
      </Text>

      {showDates && (
        <div style={{ margin: '0.5rem 0' }}>
          <Text color="grey-7">{getDateRange(start, end, isPresentCompany)}</Text>
        </div>
      )}

      <Markdown>{description}</Markdown>
    </>
  );
};

export default React.memo(Experience);
